import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _class;
import { Component } from 'react';
import { observer, engineConfig } from '@alilc/lowcode-editor-core';
import { BuiltinSimulatorHostView } from '../builtin-simulator';
import './project.less';
export var BuiltinLoading = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BuiltinLoading, _Component);
  function BuiltinLoading() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = BuiltinLoading.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "engine-loading-wrapper"
    }, /*#__PURE__*/React.createElement("img", {
      width: "154",
      height: "100",
      src: "https://img.alicdn.com/tfs/TB1CmVgayERMeJjy0FcXXc7opXa-308-200.gif"
    }));
  };
  return BuiltinLoading;
}(Component);
export var ProjectView = observer(_class = /*#__PURE__*/function (_Component2) {
  _inheritsLoose(ProjectView, _Component2);
  function ProjectView() {
    return _Component2.apply(this, arguments) || this;
  }
  var _proto2 = ProjectView.prototype;
  _proto2.componentDidMount = function componentDidMount() {
    var _this = this;
    var designer = this.props.designer;
    var project = designer.project;
    project.onRendererReady(function () {
      _this.forceUpdate();
    });
  };
  _proto2.render = function render() {
    var _project$simulator;
    var designer = this.props.designer;
    var project = designer.project,
      simulatorProps = designer.projectSimulatorProps;
    var Simulator = designer.simulatorComponent || BuiltinSimulatorHostView;
    var Loading = engineConfig.get('loadingComponent', BuiltinLoading);
    return /*#__PURE__*/React.createElement("div", {
      className: "lc-project"
    }, /*#__PURE__*/React.createElement("div", {
      className: "lc-simulator-shell"
    }, !(project !== null && project !== void 0 && (_project$simulator = project.simulator) !== null && _project$simulator !== void 0 && _project$simulator.renderer) && /*#__PURE__*/React.createElement(Loading, null), /*#__PURE__*/React.createElement(Simulator, simulatorProps)));
  };
  return ProjectView;
}(Component)) || _class;